import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type {
  PaymentRequestListItem,
  PaymentRequestStatus,
} from "./paymentRequest"

export type ListPaymentRequestsResponseItem =
  PaymentRequestListItem

export type ListPaymentRequestsFilter = {
  search?: string
  customerId?: string
  status?: PaymentRequestStatus
}

export type ListPaymentRequestsQuery =
  ListPaymentRequestsFilter & Pagination

const listPaymentRequests = async (
  query?: ListPaymentRequestsQuery
): Promise<Paginate<ListPaymentRequestsResponseItem[]>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      Paginate<ListPaymentRequestsResponseItem[]>
    >
  >("/beepaidgo/payment-requests/", { query })

  return {
    ...body,
    items: body.items.map((paymentRequest) => ({
      ...paymentRequest,
      createdAt: DateFns.parseISO(paymentRequest.createdAt),
    })),
  }
}

export const usePaymentRequests = (
  query?: MaybeRef<ListPaymentRequestsQuery>
) =>
  useQuery({
    queryKey: [PAYMENT_REQUESTS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listPaymentRequests(query_),
  })
